module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-filter-expression"
  }, [_c('div', {
    staticClass: "simple-expression",
    class: _vm.definition.classes
  }, [_vm._l((_vm.expression.args), function(arg, argId) {
    return (_vm.definition.isList) ? _c('div', {
      staticClass: "arg"
    }, [_c('FilterExpression', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.definition.isList) ? _c('button', {
    staticClass: "mdl-button add-button",
    on: {
      "click": _vm.addArg
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Add\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d1427e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/query/SimpleFilterExpression.vue
// module id = 438
// module chunks = 0